import { NavLink } from 'react-router-dom';
import { Box, Breadcrumbs } from '@mantine/core';

interface DetailPageNavigationProps {
    providerName?: string;
}

export const DetailPageNavigation = ({ providerName }: DetailPageNavigationProps) => {
    const breadcrumbs = [
        { title: 'Home', href: '/dashboard' },
        { title: 'Billing', href: '/products' },
        { title: 'Billing Providers', href: '/billing/providers' },
        { title: providerName || 'Provider Details' }
    ].map((item, index) => (
        <Box key={index}>
            {item.href ? <NavLink to={item.href}>{item.title}</NavLink> : item.title}
        </Box>
    ));

    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};
